import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 10h14","key":"svg-0"}],["path",{"d":"M5 14h14","key":"svg-1"}]]

const IconEqual = createReactComponent('outline', 'equal', 'Equal', __iconNode);

export default IconEqual;